// @Version: 1.0.3
import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterContentInit, AfterViewChecked, ChangeDetectorRef, Component, ElementRef, inject, Inject, Injector, OnInit, Renderer2, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BREAKPOINTS, TRANSLATE_PATH, VIEWPORTCLASS, FIELD_APPEARANCE, DESIGN_DEFAULT } from './shared/shared.model';
import { ResponsiveService } from './shared/services/responsive/responsive.service';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { SharedOpenapiCastService } from 'build/project/openapi-cast/shared/shared-openapi-cast.service';
import { DOCUMENT } from '@angular/common';
import { TranslateDesignPipe } from './shared/pipes/translate-design/translate-design.pipe';


UntilDestroy()
@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
   standalone: false
})

export class AppComponent implements AfterViewChecked, AfterContentInit, OnInit {  

   public done$$ = signal(false);

   public redirectLink: string = "";
   public sResponsive: ResponsiveService = inject(ResponsiveService);
   public pTranslateDesign: TranslateDesignPipe = inject(TranslateDesignPipe);
   public sSharedOpenapi: SharedOpenapiCastService = inject(SharedOpenapiCastService);

   private cdRef_: ChangeDetectorRef = inject(ChangeDetectorRef);
   private breakpointObserver_: BreakpointObserver = inject(BreakpointObserver);
   private elemRef_: ElementRef = inject(ElementRef);
   private renderer_: Renderer2 = inject(Renderer2);
   private injector_: Injector = inject(Injector);

   constructor (@Inject(DOCUMENT) private document: Document) {}

   ngOnInit (): void {     
      this.setViewPort().subscribe();

      const valueButtonMode = this.pTranslateDesign.transform(TRANSLATE_PATH.BUTTONMODE);
      if (valueButtonMode && valueButtonMode == DESIGN_DEFAULT.FIELDMODE_SQUARE ) this.renderer_.addClass(this.elemRef_.nativeElement, DESIGN_DEFAULT.CLASS_FIELDMODE_SQUARE);

      const valueFieldMode = this.pTranslateDesign.transform(TRANSLATE_PATH.FIELDMODE);
      const result = this.injector_.get(MAT_FORM_FIELD_DEFAULT_OPTIONS);
      result.appearance = valueFieldMode == 1 ? FIELD_APPEARANCE.OUTLINED : FIELD_APPEARANCE.FILLED;
      result.floatLabel = FIELD_APPEARANCE.NO_FLOATING_LABEL;
      this.done$$.set(true);  
   }

   

   private setViewPort (): Observable<boolean> {
      return this.breakpointObserver_.observe([BREAKPOINTS.MOBILE, BREAKPOINTS.TABLET, BREAKPOINTS.DESKTOP]).pipe(
         map(res => {
            if (res.matches) {
               this.renderer_.removeClass(this.elemRef_.nativeElement, VIEWPORTCLASS.TABLET);
               this.renderer_.removeClass(this.elemRef_.nativeElement, VIEWPORTCLASS.MOBILE);
               if (res.breakpoints[BREAKPOINTS.MOBILE]) this.renderer_.addClass(this.elemRef_.nativeElement, VIEWPORTCLASS.MOBILE);
               if (res.breakpoints[BREAKPOINTS.TABLET] && !res.breakpoints[BREAKPOINTS.DESKTOP]) this.renderer_.addClass(this.elemRef_.nativeElement, VIEWPORTCLASS.TABLET);
               return true;
            }
            else return false;
         })
      )
   }

   ngAfterContentInit (): void {
      this.sResponsive.start()

   }

   ngAfterViewChecked (): void {
      this.cdRef_.detectChanges();
   }
}   